import { CardDetails, CardDetailsRequest, SaveCardDetails, SetupPaypalResult } from '~/lib/ApiModel';
import { AsyncStore } from './AsyncStore';
import { ISiteServicesApiClient } from '~/lib/SiteServicesApiClient';
import { computed, makeObservable, runInAction } from 'mobx';
import { getAppContext } from '../AppContext';

type BillingDetails = {
    card_details: CardDetails | undefined;
};

export class BillingDetailsStore extends AsyncStore<BillingDetails, BillingDetails> {
    constructor(
        public siteServicesApiClient: ISiteServicesApiClient,
        private onCardDetailsUpdated?: () => void
    ) {
        super(
            () =>
                this.siteServicesApiClient
                    .getCardDetails()
                    .then((r) => ({ card_details: r.card_details ?? undefined })),
            { card_details: undefined }
        );
        makeObservable(this);
    }

    @computed
    get cardDetails() {
        return this.item.card_details;
    }

    async updateCardDetails(request: CardDetailsRequest): Promise<SaveCardDetails> {
        const result = await this.siteServicesApiClient.updateCardDetails(request);
        runInAction(() => {
            this.item.card_details = result.card_details ?? undefined;
        });
        this.onCardDetailsUpdated?.();
        // reload the customer to update their available payment methods
        void getAppContext().customer.load();
        return result;
    }

    async removeCardDetails(): Promise<void> {
        await this.siteServicesApiClient.deleteCardDetails();
        runInAction(() => {
            this.item.card_details = undefined;
        });
        // reload the customer to update their available payment methods
        void getAppContext().customer.load();
    }

    async setupPaypal(successUrl: string): Promise<SetupPaypalResult> {
        const result = await this.siteServicesApiClient.setupPaypal(successUrl);
        if (result.complete) {
            runInAction(() => {
                this.item.card_details = undefined;
            });
            // reload the customer to update their available payment methods
            void getAppContext().customer.load();
        }
        return result;
    }
}
